import { ReactNode, useMemo } from 'react';
import type { ProductAbbreviations } from '@/creditflowresearch/domain/Product';
import { prioritizeProductAbbreviations } from '@/creditflowresearch/ui/common/utils/products/productStyleHelpers';
import { useTitleWithLockIcon } from './useTitleWithLockIcon';

interface IUsePageTitleOptions {
  title: string | ReactNode,
  productAbbreviations: string[],
  shouldShowLock?: boolean,
  separator?: string,
}

export const usePageTitle = ({
  title,
  productAbbreviations,
  shouldShowLock = false,
  separator = '/',
}: IUsePageTitleOptions): ReactNode => {
  const formattedTitle = useMemo(() => {
    if (productAbbreviations.length === 0) {
      return title;
    }

    const prioritizedAbbreviations = prioritizeProductAbbreviations(
      productAbbreviations as ProductAbbreviations[],
    );
    const productPrefix = prioritizedAbbreviations.join(separator);

    if (typeof title === 'string') {
      return `${ productPrefix } ${ title }`;
    }

    return (
      <>
        { productPrefix } { title }
      </>
    );
  }, [title, productAbbreviations, separator]);

  return useTitleWithLockIcon({
    title: formattedTitle,
    activeItems: shouldShowLock ? [{ hasAccess: false }] : [],
  });
};
